import { FieldErrors } from './FieldErrors';

import { useFieldContext } from '.';

interface Props {
  children: React.ReactNode;
  defaultOptionLabel?: string;
  disabled?: boolean;
  label: string;
  required?: boolean;
}

export function BurnoutSelectField({ children, defaultOptionLabel, disabled, label, required = true }: Props) {
  const field = useFieldContext<string>();

  return (
    <div>
      <label htmlFor={field.name} className='block leading-6 font-medium'>
        {label}
      </label>
      <div className='mt-2'>
        <select
          disabled={disabled}
          required={required}
          value={field.state.value}
          onChange={(e) => field.handleChange(e.target.value)}
          name={field.name}
          id={field.name}
          className='ring-burnout-light-red focus:ring-burnout-blue nice-focus block w-full cursor-pointer rounded-lg border-0 bg-white px-3 py-2 text-black ring-2 transition-all duration-200 ease-in-out outline-none ring-inset placeholder:text-gray-400 focus:ring-inset'
        >
          {defaultOptionLabel && (
            <option value='' disabled>
              {defaultOptionLabel}
            </option>
          )}
          {children}
        </select>
      </div>
      <FieldErrors meta={field.state.meta} />
    </div>
  );
}
